export default {
    init() {
        const self = this
        let timer
        let stickyStatus = true

        const $banner = $('.banner')

        if ($banner.length) {

        this.$body = document.querySelector('body')
        this.$header = document.querySelector('.banner')
        this.$headerHeight = (this.$header.clientHeight) * 2
        this.headerSticky = false
        this.lastScrollTop = 0

        $(window).scroll(function(){
            if (timer) clearTimeout(timer)

            timer = setTimeout(function(){
                self.headerStickyNav(stickyStatus)
            }, 20)
        })

        }
    },

    headerStickyNav(stickyStatus){
        let scrollAmount = $(window).scrollTop()

        if( stickyStatus ){
            if ( scrollAmount >= 600 ){
                $('body').addClass('sticky-active')
            } else {
                $('body').removeClass('sticky-active')
            }
        }

        // Hide and show sticky header
        if (scrollAmount > 1200 && scrollAmount > this.lastScrollTop){
            if (this.headerSticky === false){
                this.$body.classList.add('no-sticky')
                this.headerSticky = true
            }
        } else if (scrollAmount < this.$headerHeight || scrollAmount < this.lastScrollTop) {
            if (this.headerSticky === true){
                this.$body.classList.remove('no-sticky')
                this.headerSticky = false
            }
        }
        this.lastScrollTop = scrollAmount
    },
}



// WEBPACK FOOTER //
// ./scripts/routes/sticky.js